import React, { FC, useCallback } from "react";
import { bottombarCSS } from "../../../styles/navigationStyle";
import { useLayerClickActive, useToggleLayerClickActive } from "../../../state";

const Bottombar: FC = () => {
  const toggleLayerClickActive = useToggleLayerClickActive();
  const onToggleLayerClick = useCallback(() => {
    toggleLayerClickActive();
  }, [toggleLayerClickActive]);

  const layerClickActive = useLayerClickActive();

  const buttons = [
    {
      icon: "fa fa-info",
      callback: onToggleLayerClick,
    },
  ];

  return (
    <div style={bottombarCSS as any}>
      {buttons.map((button, index) => {
        if (sessionStorage.getItem("showInfoButton") === "true" && button.icon === "fa fa-info") {
          return (
            <div
              className="col-20"
              key={index}
              onClick={button.callback}
              style={!layerClickActive ? Object.assign({}, bottombarCSS.li, bottombarCSS.liDisabled) : (bottombarCSS.li as any)}
            >
              <i className={button.icon} style={bottombarCSS.li.icon} />
            </div>
          );
        } else {
          return (
            <div
              className="col-20"
              key={index}
              onClick={button.callback}
              style={Object.assign({}, bottombarCSS.li, bottombarCSS.liHide) as any}
            >
              <i className={button.icon} style={bottombarCSS.li.icon} />
            </div>
          );
        }
      })}
    </div>
  );
};

export default Bottombar;
